import { Controller } from "@hotwired/stimulus"

// Manages dynamic amenities form for seasons
export default class extends Controller {
  static targets = ["container", "template"]
  static values = { amenities: Array }

  connect() {
    this.render()
  }

  render() {
    this.containerTarget.innerHTML = ""
    this.amenitiesValue.forEach((amenity, index) => {
      this.addAmenityRow(amenity, index)
    })
    this.updateHiddenFields()
  }

  addAmenityRow(amenity = null, index = null) {
    const template = this.templateTarget.content.cloneNode(true)
    const row = template.querySelector(".amenity-row")
    
    const id = amenity?.id || this.generateId()
    row.dataset.amenityId = id
    row.dataset.index = index !== null ? index : this.amenitiesValue.length

    // Set values if editing existing amenity
    if (amenity) {
      row.querySelector('[data-field="name"]').value = amenity.name || ""
      row.querySelector('[data-field="description"]').value = amenity.description || ""
      row.querySelector('[data-field="icon"]').value = amenity.icon || "tickets"
    }

    // Add change listeners
    row.querySelectorAll('[data-field]').forEach(input => {
      input.addEventListener('change', () => this.updateFromDOM())
      input.addEventListener('input', () => this.updateFromDOM())
    })

    this.containerTarget.appendChild(row)
  }

  addAmenity(event) {
    event.preventDefault()
    const newAmenity = {
      id: this.generateId(),
      name: "",
      description: "",
      icon: "tickets"
    }
    this.amenitiesValue = [...this.amenitiesValue, newAmenity]
    this.addAmenityRow(newAmenity, this.amenitiesValue.length - 1)
    this.updateHiddenFields()
  }

  removeAmenity(event) {
    event.preventDefault()
    const row = event.target.closest('.amenity-row')
    const id = row.dataset.amenityId
    
    this.amenitiesValue = this.amenitiesValue.filter(a => a.id !== id)
    row.remove()
    this.updateHiddenFields()
  }

  updateFromDOM() {
    const rows = this.containerTarget.querySelectorAll('.amenity-row')
    const amenities = []
    
    rows.forEach(row => {
      amenities.push({
        id: row.dataset.amenityId,
        name: row.querySelector('[data-field="name"]').value,
        description: row.querySelector('[data-field="description"]').value,
        icon: row.querySelector('[data-field="icon"]').value
      })
    })
    
    this.amenitiesValue = amenities
    this.updateHiddenFields()
  }

  updateHiddenFields() {
    // Remove existing hidden fields
    this.element.querySelectorAll('input[name^="season[amenities]"]').forEach(el => el.remove())
    
    // Create new hidden fields for each amenity
    this.amenitiesValue.forEach((amenity, index) => {
      ['id', 'name', 'description', 'icon'].forEach(field => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = `season[amenities][${index}][${field}]`
        input.value = amenity[field] || ''
        this.element.appendChild(input)
      })
    })
  }

  generateId() {
    return Math.random().toString(36).substring(2, 14)
  }
}
